import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router/auto";
import App from "./App.vue";

import "@mdi/font/css/materialdesignicons.min.css";

import "tailwindcss/tailwind.css";
import "../src/assets/css/modal-windows.css";
import "../src/assets/css/documents.css";
import { authGuard, createAuth0 } from "@auth0/auth0-vue";



import {
  vectiAppAuth0ClientId,
  vectiAppAuth0Domain,
  vectiAppAuth0RedirectUrl,
} from "./context/Shared/infrastructure/Config";


const router = createRouter({
//  history: createWebHashHistory(),
  history: createWebHistory(),

});



router.beforeEach(async (to, _from, next) => {
 
  if (to.path === '/register') { 
    next();
    return;
  };

  if (to.path === '/terms-conditions') {
    next();
    return;
  };

  if (to.path === '/success') {
    next();
    return;
  };

  if (to.path === '/fail') {
    next();
    return;
  };


  if (to.path === '/') {
    next();
    return;
  };


  if (to.path === '/home') {
    console.log("vamos a home");
    next();
    return;
  };


  if (to.path !== "/" && to.path !== "/register" && to.path !== "/terms-conditions") {
    console.log("Guardando previousRoute: " + to.fullPath);
    localStorage.setItem('previousRoute', to.fullPath);
  } else {
  
    localStorage.removeItem('previousRoute');
  }

  try {
    const isAuthenticated = await authGuard(to);

    if (isAuthenticated) {
  
      next();
    } else {
  
      next("/")
      //next({ path: "/go", replace: true });
      return;
    }


  } catch (error) {
    console.error("Error en authGuard:", error);
    //next("/"); // Redirige a Landing en caso de error
  }

});



import store from "./store";
//import click from "./store/click";

const auth0 = createAuth0({
  domain: vectiAppAuth0Domain(), //TODO: Parametrizar
  clientId: vectiAppAuth0ClientId(),
  authorizationParams: {
    redirect_uri: vectiAppAuth0RedirectUrl(), //TODO: Parametrizar
    audience: "https://" + vectiAppAuth0Domain() + "/api/v2/", //TODO: Parametrizar
    //      skipRedirectCallback: true, // Evita que el callback funcione en cualquier URL
  },
});

const app = createApp(App);

// const authGuard = createAuthGuard(app);

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "../src/assets/css/main.css";
//import { createWebHashHistory } from "vue-router/auto";
//import './plugins/validation-rules';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          background: "#f7f8fb",
          surface: "#ffffff",
          "surface-variant": "#f1f5f9",
          primary: "#0f4c5c",
          secondary: "#189ab4",
          error: "#ef4444",
          info: "#0284c7",
          success: "#16a34a",
          warning: "#f59e0b",
        },
      },
      dark: {
        dark: true,
        colors: {
          background: "#0b111b",
          surface: "#0f172a",
          "surface-variant": "#111827",
          primary: "#38bdf8",
          secondary: "#22d3ee",
          error: "#f87171",
          info: "#60a5fa",
          success: "#22c55e",
          warning: "#fbbf24",
        },
      },
    },
  },
});

app.use(vuetify);
app.use(router);

app.use(store);
//app.use(click);
app.use(auth0);

const applyColorScheme = (isDark: boolean) => {
  document.documentElement.classList.toggle("dark", isDark);
  vuetify.theme.global.name.value = isDark ? "dark" : "light";
};

const mediaQuery = window.matchMedia?.("(prefers-color-scheme: dark)");
applyColorScheme(mediaQuery?.matches ?? false);
if (mediaQuery) {
  const handleChange = (event: MediaQueryListEvent) => applyColorScheme(event.matches);
  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", handleChange);
  } else if (typeof mediaQuery.addListener === "function") {
    mediaQuery.addListener(handleChange);
  }
}

app.mount("#app");

const originalLog = console.log;

console.log = function (...args) {
  if (import.meta.env.MODE === "development") {
    originalLog(`[MyLog][${new Date().toISOString()}]`, ...args);
  }
};
